import React from "react";
import profile from "../../assets/images/dashboard/profile.png";
import goal from "../../assets/images/dashboard/goal.png";
import money from "../../assets/images/dashboard/money.png";

const DashboardProfile = () => {
  return (
    <div className='dashboard-profile-content'>
      <div className='dashboard-profile-detail'>
        <div className='dashboard-profile'>
          <img src={profile} alt='profile' />
          <div className='profile-name'>
            <h4>John</h4>
            <p>Web Designer & Developer</p>
          </div>
        </div>
        <div className='profile-rating'>
          <div className='profile-rating-left'>
            <img src={goal} alt='goal' />
            <p>18</p>
          </div>
          <div className='profile-rating-right'>
            <img src={money} alt='money' />
            <p>$1890</p>
          </div>
        </div>
        <div className='profile-project'>
          <div className='profile-project-head'>
            <h2>Project</h2>
            {/* <span>+</span> */}
          </div>
          <div className='profile-project-detail'>
            <ul>
              <li>#Dashboard</li>
              <li>#Temlate design</li>
              <li>#Dashboard - Admin panel</li>
              <li>#Creative Template</li>
            </ul>
          </div>
        </div>
        <div className='project-search'>
          <div className='profile-project-head'>
            <h2>Contact</h2>
          </div>
          <div className='profile-project-detail'>
            {/* <p>Invitation</p> */}
            <p>Message</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardProfile;
